export default {
  MODULE_NAME: 'profile',
};
